import React, { useEffect, useRef } from 'react'

import { Spinner } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import Button from 'components/Button'
import Separator from 'components/Separator'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TestIDs } from 'test/utils/testIds'
import theme from 'theme'

export const AGREE_BUTTON_TEXT = 'I agree'

type Props = {
  isSubmitting: boolean
  isDisabled: boolean
  handlePress: () => void
  setDisclaimerOffset: (offset: number) => void
}

const Disclaimer = styled.p`
  font-size: 14px;
  line-height: 22px;
  margin: 40px 0 80px;
  padding-top: 40px;
  border-top: 1px solid ${theme.colors.ivory};

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin: 50px 0 0;
  }
`

const StyledButton = styled(Button)`
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin-top: 50px;
  }
`

const TrackedAgreeButton = withClickTrack<{}, { disabled: boolean; onPress: () => void }>({
  cta_title: AGREE_BUTTON_TEXT,
  object_name: 'referralDisclosureAgree',
  screen_name: 'referralDisclosure',
  screen: 'referralDisclosure',
})(StyledButton)

export const SignButton = (props: Props) => {
  const { isLoadingRemoteStrings, getRemoteString } = useRemoteStrings()
  const disclaimerRef = useRef(null)

  useEffect(() => {
    if (!isLoadingRemoteStrings && disclaimerRef) {
      props.setDisclaimerOffset(disclaimerRef.current.offsetHeight)
    }
  }, [isLoadingRemoteStrings, disclaimerRef])

  return isLoadingRemoteStrings ? (
    <Spinner />
  ) : (
    <>
      <Disclaimer ref={disclaimerRef} data-testid={TestIDs.REFERRAL_DISCLOSURE.DISCLAIMER_TEXT}>
        {getRemoteString({
          key: 'referral_disclosure.disclaimer.variable',
          variables: [AGREE_BUTTON_TEXT],
        })}
      </Disclaimer>
      <Separator />
      <TrackedAgreeButton
        disabled={props.isDisabled}
        onPress={props.handlePress}
        data-testid={TestIDs.REFERRAL_DISCLOSURE.SIGN_BUTTON}
      >
        {props.isSubmitting ? <Spinner height={20} width={20} color="white" /> : AGREE_BUTTON_TEXT}
      </TrackedAgreeButton>
    </>
  )
}
